import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IconComponent} from './components/icon/icon.component';
import {ServiceCardTitleComponent} from './components/service-cards/service-card-title/service-card-title.component';
import {ServiceCardComponent} from './components/service-cards/service-card/service-card.component';
import {TestSelectorComponent} from './components/service-cards/test-selector/test-selector.component';
import {PrimeNgModule} from './modules/prime-ng/prime-ng.module';

import {CookieConsentComponent} from '@app/cookie-consent/components/cookie-consent/cookie-consent.component';
import {ExpiredTokenComponent} from '@app/signUp/components/expired-token/expired-token.component';
import {TranslateModule} from '@ngx-translate/core';
import {MessageService} from 'primeng/api';
import {AlgoliaSearchComponent} from './components/algolia-search/algolia-search.component';
import {BuildNumberComponent} from './components/build-number/build-number.component';
import {FooterComponent} from './components/footer/footer.component';
import {HeaderComponent} from './components/header/header.component';
import {LanguageSelectorComponent} from './components/language-selector/language-selector.component';
import {LoginInfoComponent} from './components/login-info/login-info.component';
import {LogoComponent} from './components/logo/logo.component';
import {MaskedCalendarComponent} from './components/masked-calendar/masked-calendar.component';
import {OrderStepperComponent} from './components/stepper/order-stepper/order-stepper.component';
import {BuildNumberDirective} from './directives/build-number.directive';
import {DynamicFormModule} from './modules/dynamic/dynamic-form.module';
import {HighlightPipe} from './pipes/highlight.pipe';

const themeUiComponents = [
  ServiceCardComponent,
  TestSelectorComponent,
  ServiceCardTitleComponent,
  IconComponent,
  OrderStepperComponent,
  LogoComponent,
  LoginInfoComponent,
  BuildNumberDirective,
  BuildNumberComponent,
  FooterComponent,
  HeaderComponent,
  CookieConsentComponent,
  LanguageSelectorComponent,
  MaskedCalendarComponent,
  AlgoliaSearchComponent,
  HighlightPipe,
];

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    PrimeNgModule,
    ...themeUiComponents,
    TranslateModule,
    DynamicFormModule,
    ExpiredTokenComponent,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    PrimeNgModule,
    ServiceCardComponent,
    ...themeUiComponents,
    TranslateModule,
    DynamicFormModule,
    ExpiredTokenComponent,
  ],
  providers: [MessageService],
})
export class SharedModule {}
